<div class="eq-modal">
    <div class="eq-modal__header">
        <h3>{{ isEdit ? 'Edit equipment' : 'Add equipment' }}</h3>
        <button type="button" class="eq-modal__close" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
    </div>

    <form class="eq-modal__body" (ngSubmit)="save()">
        <div class="field-row">
            <label class="field">
                <span>Code <em>*</em></span>
                <input ngbAutofocus type="text" name="code" [(ngModel)]="code" (ngModelChange)="onCodeChange()"
                    placeholder="DP-71" autocomplete="off" [class.invalid]="codeInvalid" />
            </label>
            <label class="field">
                <span>Slug <em>*</em></span>
                <input type="text" name="slug" [(ngModel)]="slug" (input)="onSlugInput()" placeholder="dp-71"
                    autocomplete="off" [class.invalid]="slugInvalid" />
            </label>
        </div>

        @if (slugChanged) {
            <!-- The slug is the public address; old links stop resolving. -->
            <p class="warn">Changing the slug changes this product's public URL (/equipment/{{ slug }}). Existing links
                to <strong>/equipment/{{ equipment?.slug }}</strong> will stop working.</p>
        }

        <label class="field">
            <span>Name</span>
            <input type="text" name="name" [(ngModel)]="name" placeholder="DIN Rail Power Supply"
                autocomplete="off" />
        </label>

        <label class="field">
            <span>Features</span>
            <textarea name="features" [(ngModel)]="features" rows="3"
                placeholder="Comma-separated feature summary, as published"></textarea>
        </label>

        <div class="field">
            <span>Photo</span>
            <!-- Click or drop. The file is previewed locally and uploaded to S3
                 by the server when the form is saved. -->
            <div class="dropzone" [class.dragging]="dragging" [class.has-image]="!!previewUrl"
                (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)"
                (click)="fileInput.click()">
                @if (previewUrl) {
                    <img [src]="previewUrl" alt="" class="preview" />
                    <div class="dropzone__meta">
                        <span class="fname">{{ imageName || 'Current photo' }}</span>
                        <button type="button" class="link-btn danger" (click)="clearImage(); $event.stopPropagation()">
                            Remove
                        </button>
                    </div>
                } @else {
                    <p class="dropzone__hint">
                        <strong>Drop an image here</strong> or click to choose<br />
                        png, jpg, webp or gif · up to 5MB
                    </p>
                }
            </div>
            <input #fileInput type="file" class="file-input" accept="image/png,image/jpeg,image/webp,image/gif"
                (change)="onFilePicked($event)" />
            @if (imageError) {
                <p class="err">{{ imageError }}</p>
            }
        </div>

        <div class="specs">
            <div class="specs__head">
                <span>Specifications</span>
                <button type="button" class="link-btn" (click)="addSpec()">+ Add row</button>
            </div>

            @if (specifications.length === 0) {
                <p class="hint">No specifications. The detail page shows "No published specifications" instead.</p>
            } @else {
                @for (spec of specifications; track $index) {
                    <div class="spec-row">
                        <input type="text" [(ngModel)]="spec.label" [name]="'spec-label-' + $index"
                            placeholder="Label (e.g. Voltage)" autocomplete="off" />
                        <input type="text" [(ngModel)]="spec.value" [name]="'spec-value-' + $index"
                            placeholder="Value (e.g. 24V DC)" autocomplete="off" />
                        <button type="button" class="icon-btn danger" (click)="removeSpec($index)"
                            aria-label="Remove row">&times;</button>
                    </div>
                }
            }
        </div>

        <button type="submit" class="eq-modal__submit">{{ isEdit ? 'Save changes' : 'Create' }}</button>
    </form>
</div>
